import { render, staticRenderFns } from "./plan2025.vue?vue&type=template&id=d4ae1836&scoped=true"
import script from "./plan2025.vue?vue&type=script&lang=js"
export * from "./plan2025.vue?vue&type=script&lang=js"
import style0 from "./plan2025.vue?vue&type=style&index=0&id=d4ae1836&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4ae1836",
  null
  
)

export default component.exports